/* eslint-disable import/prefer-default-export */
// GENERAL
export const SOMETHING_WENT_WRONG         = "Something went wrong. Please try again later.";
export const REFRESH_AND_TRY_AGAIN_ERROR  = "Something went wrong. Please refresh the page and try again.";
export const GENERAL_VALIDATION_ERROR     = "HLK:Please ensure that all fields are filled out with valid values.\n";
export const NO_MATCHING_OPTIONS          = "Sorry, no matching options.";
export const PASSWORD_NOT_MATCH           = "The password confirmation does not match.";
export const PASSWORD_MUST_BE_LONGER      = "The new password must be at least 8 characters.";
export const EMAIL_VERIFICATION_ERROR     = "Your email address is not verified.";
export const REDIRECT_TO_ONBOARDING_ERROR = "User do not have any companies";
export const NOT_ALLOWED                  = "You are not allowed to perform this action.";
export const SERVER_ERROR                 = "The server was unable to complete your request. Please try again later.";

// ONBOARDING
export const NEED_BOTH_DIRECTOR_AND_SHAREHOLDER = "You need to add both directors and shareholders.";
export const NEED_SHAREHOLDER                   = "You need to add shareholders.";
export const NEED_DIRECTOR                      = "You need to add directors.";
export const EXIST_SHAREHOLDER_WITH_SAME_TYPE   = "Shareholder with same type already exist.";

export const SAVING_INTO_CART_ERROR = "Error saving into cart.";

export const ATTACH_DOCUMENT_ERROR = "It seems like you have forgotten to attach documents. Attach documents by clicking the 'Attached Documents' button." ;

// FORMATIONS
export const ADD_ENSTON_DIRECTOR_ERROR                         = "The client has purchased the Nominee Director Service. Please add a nominee director.";
export const DIRECTOR_FILL_OUT_ALL_FIELD_ERROR   = "For each director, please provide all the relevant information.";
export const SHAREHOLDER_FILL_OUT_ALL_FIELD_ERROR = "For each shareholder, please provide all the relevant information.";
export const TOTAL_SHARE_PERCENTAGE_ERROR                      = "Total share percentage must be 100%.";

export const BENEFICIAL_OWNER_FILL_OUT_ALL_FIELD_ERROR = "For each beneficial owner, please provide all the relevant information.";

export const REGISTRABLE_CONTROLLER_FILL_OUT_ALL_FIELD_ERROR = "For each registrable controller, please provide all the relevant information.";

// SIGN
export const ERROR_MUST_FILL_POA_INFO = "You must complete the required POA information in shareholder section to generate incorporation documents.";
export const ERROR_MUST_COMPLETE_PRE_INCORPORATION_PROCESS         = "You must complete the pre-incorporation process by sending the documents to the user in order to move on to the next step.";
export const ERROR_WHILE_TRYING_TO_SIGN_SUBMITTED_TO_SIGN_DOCUMENT = "Please wait until the document has been signed.";
export const ERROR_WHILE_TRYING_TO_SIGN_ALREADY_SIGNED_DOCUMENT    = "You have already signed the document.";
export const ERROR_WHILE_TRYING_TO_VIEW_SIGNING_PROCESS_DOCUMENT = "Please wait for a few seconds while this document is being processed.";
export const SEND_SIGNATURE_INVITATION_MAIL_ERROR = "Error while trying to send your mails. please try again";
export const ERROR_DOWNLOAD_MUST_HAVE_AT_LEAST_ONE_DOCUMENTS = "Please select the documents in order to download.";
export const ERROR_SEND_EMAIL_MUST_HAVE_AT_LEAST_ONE_DOCUMENTS = "Please select the documents in order to email.";

// DOCUMENTS
export const DOCUMENT_COULD_NOT_LOAD = "Documents could not be loaded.";

// HTTP STATUS CODE
export const BACKEND_VALIDATION_STATUS_CODE = 422;

// CLIENTS
export const ERROR_SEND_EMAIL_MUST_HAVE_AT_LEAST_ONE_CLIENT = "Please select the clients in order to email.";

// TRANSFER FORM
export const SHOULD_HAVE_AT_LEAST_ONE_TRANSFER_RECORD = "To proceed to the next step, please add the transfer record.";

